import React, { useState, useEffect } from "react"
import { Select, TextInput } from "evergreen-ui"

export function UpDownInput(props) {
  const [dir, setDir] = useState((props.value || 0) >= 0 ? 'Up' : 'Down');
  const [value, setValue] = useState(Math.abs(props.value || 0));

  useEffect(() => {
    let v = Math.abs(value);
    props.onChange && props.onChange(dir == 'Up' ? v : -v);
  }, [value, dir]);

  return <div style={{ display: "flex", flex: "2" }}> 
  <TextInput flex={1} onChange={(e) => setValue((e.target.value > - 1 ? (e.target.value > 360 ? 360 : e.target.value) : Math.abs(0)) || Math.abs(0))} width={"100%"} name="angle" placeholder="0" type='number' max={360} value={value} marginRight="5%" />

    <Select value={dir} onChange={(event) => { setDir(event.target.value) }}>
      <option value="Up">Up</option>
      <option value="Down">Down</option>
    </Select></div>

}